import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Container from "../../components/Container";
import Navbar from "../../components/Navbar";
import QuizQuestions from "../../components/quiz/QuizQuestions";
import Error from "../../components/ui/Error";
import Loading from "../../components/ui/Loading";
import {
  useGetQuizMarkQuery,
  useGetVideoQuizzesQuery,
} from "../../features/quizzes/quizzesApi";
import { useGetVideoQuery } from "../../features/videos/videosApi";
export default function Quiz() {
  const { videoId } = useParams();
  const { data: video } = useGetVideoQuery(videoId);
  const {
    data: quizzes,
    isLoading,
    isError,
    error,
  } = useGetVideoQuizzesQuery(videoId);

  const user = useSelector((state) => state.auth.user);
  const { data: quizMark } = useGetQuizMarkQuery({
    studentId: user.id,
    videoId: videoId,
  });

  let content = null;
  if (isLoading) {
    content = <Loading />;
  } else if (!isLoading && isError) {
    content = <Error message={error} />;
  } else if (
    !isLoading &&
    !isError &&
    quizzes.length > 0 &&
    quizMark?.length > 0
  ) {
    content = (
      <div className="w-full text-center text-4xl">
        You've already submitted this Quiz!!
      </div>
    );
  } else if (!isLoading && !isError && quizzes.length === 0) {
    content = (
      <div style={{ textAlign: "center", fontSize: "22px" }}>
        No quizzes found for this video!
      </div>
    );
  } else if (
    !isLoading &&
    !isError &&
    quizzes.length > 0 &&
    quizMark?.length === 0
  ) {
    content = <QuizQuestions video={video} quizzes={quizzes} />;
  }

  useEffect(() => {
    document.title = "Quiz";
  });
  return (
    <>
      <Navbar />
      <Container>
        <div className="mb-8">
          <h1 className="text-2xl font-bold">Quizzes for "{video?.title}"</h1>
          <p className="text-sm text-slate-200">
            Each question contains 5 Mark
          </p>
        </div>

        {content}
      </Container>
    </>
  );
}
